import LeftLayout from "./pageHeader/LeftLayout";
import { FrownOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import { useHistory } from "react-router-dom";
const NotFound = () => {
    const history = useHistory();
    return (
        <>
            <LeftLayout>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Result
                        status="404"

                        icon={<FrownOutlined style={{ fontSize: 60, color: '#faad14' }} />}
                        title={
                            <div style={{ fontSize: '48px', fontWeight: 'bold' }}>
                                404
                            </div>
                        }
                        subTitle={
                            <div style={{ fontSize: '20px', color: '#666' }}>
                                Sorry, the page you visited does not exist.
                            </div>
                        }
                        extra={
                            <Button type="primary"  onClick={() => history.push("/")}>
                                Back to Home
                            </Button>
                        }
                    />
                </div>
            </LeftLayout>
        </>

    )
}
export default NotFound;